import { PackageInvoicesRow } from "./columnsPackageInvoices";
import { ElectronicDocumentItem } from "shared/api/services";

export const mapElectronicDocumentsToPackageInvoices = (
  items: ElectronicDocumentItem[],
): PackageInvoicesRow[] => {
  return items.map((item, index) => ({
    rowId: index.toString(),
    numeroFactura: item.documentNumber,
    nit: item.provider.employerIdNumber,
    razonSocial: item.provider.name,
    totalFactura: item.totalValue,
    estadoFactura: item.stateName,
    valorAvalado: item.acceptedConsolidatedValue,
    valorGlosaAceptada: item.sustainedConsolidatedValue,
    valorEnNoAcuerdo: item.consolidatedInNoAgreementValue,
    auditorAutoriza: item.auditorName || "",
  }));
};
